// The /customers route (Umer, 2026-10-17). The owner gets the full list; a user the owner switched on
// (services/customerLookup.ts) gets the search-only page; everyone else — a super admin included — is
// sent to their own home page, the same as a typed URL for any page their role does not have.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { defaultPathForRole } from '../services/roleHome';
import { useCustomerLookup } from '../services/customerLookup';
import { isOwner } from '../services/roles';

// The page itself stays lazy (App.tsx), so it comes in as a render function: fullList for the owner.
export const CustomersRoute: React.FC<{ children: (fullList: boolean) => React.ReactNode }> = ({ children }) => {
  const { currentUser } = useApp();
  const allowed = useCustomerLookup(currentUser);
  if (!currentUser || allowed === null) return null;
  if (!allowed) return <Navigate to={defaultPathForRole(currentUser.role)} replace />;
  return <>{children(isOwner(currentUser.role))}</>;
};
